<template>
    <div class="wrapper">
        <div class="register__container">
                <div class="logo__image">
                  <router-link to="/main">
                    <img src="../../assets/logo/vlab-logo.jpg">
                  </router-link>
                </div>
                <v-form class="form__contents" v-model="valid">
                    <div class="form-content">
                       <span class="font-weight-bold">이메일(Email)</span><br>
                        <v-text-field
                            clearable
                            outlined
                            dense
                            required
                            v-model="temp"
                            :disabled="getSocial.register==false? true: false"
                            :error="this.errors.email!=null ? true : false"
                            :error-messages="this.errors.email"
                            @focus="resetMsgError('email')"
                            :rules="[rule.require, rule.email]"
                            name="email"
                            id="email"
                            type="text"
                        ></v-text-field>
                    </div>
                    <div v-if="getSocial.register==false? false: true" class="form-flex-content">
                      <v-row cols="12">
                        <v-col class="form-content py-0" cols="12" sm="12" md="6" lg="6">
                            <span class="font-weight-bold">비밀번호(Password)</span><br>
                            <v-text-field
                                clearable
                                outlined
                                dense
                                required
                                v-model="password"
                                :error="errors.password!=null ? true : false"
                                :error-messages="errors.password"
                                @focus="resetMsgError('password')"
                                :rules="[rule.password, rule.require]"
                                id="password"
                                name="password"
                                type="password"
                            />
                        </v-col>
                        <v-col class="py-0 form-content" cols="12" sm="12" md="6" lg="6">
                            <span class="font-weight-bold">비밀번호 확인(Confirm)</span><br>
                            <v-text-field
                                clearable
                                outlined
                                dense
                                required
                                v-model="check_password"
                                :rules="[rule.require, checkPassword]"
                                id="check_password"
                                name="check_password"
                                type="password"
                            />
                        </v-col>
                      </v-row>
                    </div>
                    <div class="form-flex-content">
                        <div class="form-content">
                            <span class="font-weight-bold">이름(Full Name)</span><br>
                             <v-text-field
                                clearable
                                outlined
                                dense
                                required
                                :hint="namehint"
                                :rules="[rule.require, rule.name]"
                                id="name"
                                name="name"
                                type="text"
                                v-model="name"
                            />
                        </div>
                    </div>
                    <div class="form-flex-content">
                      <v-row>
                        <v-col class="py-0 form-content" cols="12" sm="12" md="6" lg="6">
                            <span class="font-weight-bold">소속(Organization)</span><br>
                             <v-text-field
                                clearable
                                outlined
                                dense
                                required
                                :hint="schoolhint"
                                :rules="[rule.require]"
                                id="school"
                                name="school"
                                v-model="school"
                            />
                        </v-col>
                         <v-col class="py-0 form-content" cols="12" sm="12" md="6" lg="6">
                            <span class="font-weight-bold">전공분야(Major Field)</span><br>
                             <v-text-field
                                clearable
                                outlined
                                dense
                                required
                                :hint="departmenthint"
                                :rules="[rule.require]"
                                id="department"
                                name="department"
                                v-model="department"
                            />
                         </v-col>
                      </v-row>
                    </div>
                    <div class="check-agree-privacy">
                        <v-checkbox class="mt-0 ml-2" v-model="check_privacy" required :rules="[rule.privacy]" color="success">
                            <template v-slot:label>
                            <div>
                                <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <a
                                    style="text-decoration:none; color:#00A651"
                                    class="subtitle font-weight-bold"
                                    target="_blank"
                                    @click.stop
                                    v-on="on"
                                    href="http://www.pusan.ac.kr/kor/CMS/Board/Board.do?mCode=MN186"
                                    >개인정보 취급방침</a>
                                </template>
                                개인정보 취급방침 문서창을 띄웁니다.
                                </v-tooltip> <span class="subtitle font-weight-bold black--text">동의 (필수)</span>
                            </div>
                            </template>
                        </v-checkbox>
                    </div>
                    <hr class="divisor">
                    <div class="login__content">
                        <span class="font-weight-bold">이미 계정을 갖고 계신가요?</span>
                        <router-link to="/login"><span>로그인</span></router-link>
                    </div>
                    <div class="form-flex-content btn-content">
                      <v-row>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-btn
                              width="100%"
                              color="#5457ff"
                              :disabled="!valid || (checkRegister.check=='waiting')"
                              @click="setSignupMode(
                                  {
                                  'email':email,
                                  'password1':password,
                                  'password2':check_password,
                                  'student_name':name,
                                  'organization':school,
                                  'major':department,
                                  'student_num':student_id
                                  }
                              )"
                              @keydown.enter="setSignupMode(
                                  {
                                  'email':email,
                                  'password1':password,
                                  'password2':check_password,
                                  'student_name':name,
                                  'organization':school,
                                  'major':department,
                                  'student_num':student_id
                                  }
                              )"
                          >
                          {{(checkRegister.check=='waiting')?'가입 중입니다. 잠시만 기다려 주세요.':'가입하기(Register)'}}
                          </v-btn>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" lg="6">
                          <v-btn width="100%" class="error" @click="resetForm()">모두 지우기(RESET)</v-btn>
                        </v-col>
                      </v-row>
                    </div>
                </v-form>
            </div>
        </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { BASE_API_URL } from '../../store/api'

export default {
  data () {
    return {
      valid: false,
      errors: {
        login: null,
        email: null,
        password: null
      },
      universList: null,
      // hint
      namehint: '실명을 입력하세요. ex)홍길동',
      schoolhint: '소속을 입력하세요. ex)부산대학교',
      departmenthint: '전공분야를 입력하세요. ex)기계공학과',
      student_idhint: '학번 정보를 입력하세요',
      // end hint

      // Rules
      rule: {
        require: v => !!v || '필수사항입니다. 입력해주세요.',
        email: v => /.+@.+\..+/.test(v) || '유효한 이메일 형식이 아닙니다.',
        password: v => v.length >= 8 || '숫자와 영문을 섞어 8자 이상 입력하세요.',
        school: v => !!v || '소속을 입력해주세요.',
        name: v => v.length >= 2 || '이름을 다시 확인해주세요.',
        privacy: v => !!v || '개인정보 처리방침 동의해주세요. 필수입니다.'
      },
      password: '',
      check_password: '',
      school: '',
      email: '',
      name: '',
      department: '',
      student_id: '',
      check_privacy: false,
      waiting: false
    }
  },
  computed: {
    ...mapGetters({
      getSocial: 'auth/getSocialInfo',
      checkRegister: 'auth/getRegistered'
    }),
    checkPassword () {
      if (this.password === this.check_password) return true
      else return '작성한 비밀번호와 맞지 않습니다. 확인해주세요.'
    },
    temp: {
      get () {
        return this.getSocial.register === false
          ? this.getSocial.email
          : this.email
      },
      set (val) {
        this.email = val
      }
    }
  },
  methods: {
    signup (user) {
      this.errors.email = null
      this.$store.dispatch('auth/signup', user)
      setTimeout(() => {
        if (this.checkRegister.check) {
          this.$router.push({ name: 'Login' })
        } else if (!this.checkRegister.check) {
          this.errors.email = this.checkRegister.msg
        }
      }, 1000)
    },
    googleSignup (user) {
      this.$store.dispatch('auth/googleSignup', user)
      setTimeout(() => {
        if (this.checkRegister.check) {
          this.$router.push({ name: 'Login' })
        }
      }, 1000)
    },
    setSignupMode (user) {
      if (this.getSocial.register === false) {
        this.googleSignup(user)
      } else {
        this.signup(user)
      }
    },
    resetMsgError () {
      this.errors.email = null
    },
    resetForm () {
      this.email = ''
      this.password = ''
      this.check_password = ''
      this.name = ''
      this.school = ''
      this.department = ''
      this.student_id = ''
    },
    getUniversList () {
      axios
        .post(`${BASE_API_URL}/users/univ/`)
        .then(res => {
          this.universList = res.data.univ_name
        })
        .catch(err => {
          console.error('getUniversList', err)
        })
    }
  }

}
</script>

<style lang="scss" scoped>
.wrapper{
    position: relative;
    height: 100vh;
    //background: linear-gradient(135deg,#9EAFE5,#78E8D6);
     background: linear-gradient(135deg,#1455a4,#9EAFE5);
}
.register__container{
    position: absolute;
    background-color: white;
    border-radius: 18px;
    width: 80%;
    height: auto;
    top: 50%;
    left:50%;
    transform: translate(-50%, -50%);
    max-width: 700px;
    padding: 20px 10px;
}
.logo__image{
    text-align: center;
}
.logo__image > a > img{
    margin: 15px auto;
    padding: 5px;
    max-width: 285px;
    min-width: 285px;
    max-height: 75px;
    min-height: 75px;
}
.register_form__container{
    position: relative;
    width: 70%;
    padding: 30px 50px;
    background: white;
    height: 100%;
    border-radius: 0px 18px 18px 0px;
    float: right;
    text-align: center;
}
/* register form */
a{
    text-decoration: none;
    color: #00A651;
    font-weight: bold;
}
.register_form__container .form_title{
    width: 90%;
    margin: 0 auto;
}
.register_form__container .form_title h1{
    display: inline-block;
    font-size: 1.7rem;
    margin-right: 10px;
    color: #5457ff;
}
.register_form__container .form_title span{
    color: #777;
}
.form__contents{
    padding-bottom: 30px;
    width: 80%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.form-content{
    width: 100%;
    text-align: left;
    margin-bottom: 0px;
}
.form-content span{
    color: #444;
    margin-left: 5px;
}
.form-content input{
    width: 100%;
    border: 1px solid #ccc;
    padding: 5px 15px;
    border-radius: 4px;
}
.form-flex-content{
    display: flex;
}
.form-flex-content .form-content:first-child{
    margin-right: 0px;
}
.v-input--selection-controls{
    margin-top: 0px;
}
.v-input__slot{
    margin-bottom: 0px !important;
}
.theme--light.v-messages{
  display: none !important;
}
.login__content{
    text-align: left;
    margin: 10px 0px;
}
.login__content span{
    margin-right: 10px;
}
.form-flex-content.btn-content{
    width: 100%;
}
.form-flex-content.btn-content button.v-btn{
    color: white;
    font-weight: bold;
    font-size: 16px;
}
.form-flex-content.btn-content button.v-btn:first-child{
    margin-right: 15px;
}
.v-btn:not(.v-btn--round).v-size--default{
  padding:0px;
}
/*##Device = 저해상도 태블릿, 모바일(가로)*/
@media (min-width: 0px) and (max-width: 768px) {
  .wrapper{
    height: 120vh;
  }
  .font-weight-bold, .login__content, .check-agree-privacy,
  .form-flex-content.btn-content button.v-btn{
     font-size: 16px;
  }
  .register__container{
    width: fit-content;
    padding: 10px;
    display: flex;
    flex-direction: column;
    top: 450px;
  }
}
</style>
